import { Box } from "@mui/material";
import React from "react";
export default function FramedPhoto({ src, alt = "", frameColor = "primary.main", frameWidth = 1, padding = 8, objectFit = "cover", objectPosition = "center", sx, }) {
    return (React.createElement(Box, { sx: {
            display: "inline-block",
            border: `${frameWidth}px solid`,
            borderColor: frameColor,
            padding,
            lineHeight: 0,
            ...sx,
        } },
        React.createElement(Box, { component: "img", src: src, alt: alt, sx: {
                display: "block",
                width: "100%",
                height: "100%",
                objectFit,
                objectPosition,
            } })));
}
